<template>
	
	<el-row>
		
		<el-col :xs="24" :sm="24" :md="16" :lg="16" class="content-area__inner">
			
			<h2 class="title">Assigned Tasks ({{ todaysDate }})</h2>
			
			<el-row v-if="assignedTickets.length" :gutter="24">
				<el-col :xs="24" :sm="24" :md="12" :lg="12" v-for="(assigned, i) in assignedTickets" :key="i">
					<TicketsListItem class="card card--border dashboard-ticket twenty-margin-bottom" :class="{ 'dashboard-ticket--active': ($route.params.ticketId == assigned.ticket.public_id) }"
						:ticket="assigned.ticket"
						:key="i"
						:show-comments="false"
						:show-project-name="true"
						:show-open-ticket-button="true"
						:show-overflow-menu="false"
						@on-open="openTicket"
						@on-click="loadTicket"/>
				</el-col>
			</el-row>
			
			<p v-else>You have no assigned tasks.</p>
			
			<h2 class="title">Overdue Tasks</h2>
			
			<div class="dashboard__overdue-tasks">
				
				<el-row v-if="overdueTickets.length" :gutter="24">
					<el-col :xs="24" :sm="24" :md="12" :lg="12" v-for="(overdue, i) in overdueTickets" :key="i">
						<TicketsListItem class="card card--border dashboard-ticket twenty-margin-bottom" :class="{ 'dashboard-ticket--active': ($route.params.ticketId == overdue.ticket.public_id) }"
							:ticket="overdue.ticket"
							:key="i"
							:show-comments="false"
							:show-project-name="true"
							:show-open-ticket-button="true"
							:show-overflow-menu="false"
							@on-open="openTicket"
							@on-click="loadTicket"/>
					</el-col>
				</el-row>
				
				<p v-else>You have no overdue tasks.</p>
				
			</div>
			
		</el-col>
		
		<el-col :xs="24" :sm="24" :md="8" :lg="8" class="content-area__inner content-area__right-column no-padding">
			
			<router-view v-if="$route.params.ticketId" :key="$route.fullPath"></router-view>
			
			<p v-else class="empty-state twenty-padding">Select a task to view more information.</p>
			
			<!--<TicketDetails v-if="ticketDetails.id" class="card card--shadow" :ticket="ticketDetails"/>
			
			<p v-else>Select a task to view its details.</p>-->
				
		</el-col>
		
	</el-row>
	
</template>

<script>
	
	import TicketsListItem from "@/components/Projects/Project/TicketsListItem";
	
	import TicketCard from "@/components/TicketCard";
	import TicketDetails from "@/components/TicketDetails";
	
	import TimeBookStopWatch from "@/components/TimeBook/StopWatch";
	
	export default {
		
		name: "Home",
		
		components: { TicketCard, TicketDetails, TimeBookStopWatch, TicketsListItem },
		
		data() {
			
			return {
				
				selectedTicket: {},
				
				assignedTickets: [],
				overdueTickets: [],
				
				todaysDate: new Date().toDateString(),
				
			}
			
		},
		
		computed: {
			
			ticketDetails() {
				
				if (this.$store.getters.timebookTicket.id) {
					return this.$store.getters.timebookTicket;
				}
				
				if (this.selectedTicket.hasOwnProperty("id")) {
					return this.selectedTicket;
				}
				
				return {};
				
			}
			
		},
		
		methods: {
			
			onClickBackground() {
				this.$set(this, "selectedTicket", {});
			},
			
			openTicket(e) {
				this.$router.push({
					name: "projects/project/ticket",
					params: { projectSlug: e.ticket.project.slug, ticketId: e.ticket.public_id }
				});
			},
			
			loadTicket(e) {
				this.$router.push({
					name: "dashboard/ticket",
					params: { ticketId: e.ticket.public_id }
				});
				
				//console.log(e);
				
				// Update selected ticket.
				
				/*this.$set(this, "selectedTicket", e.ticket);
				
				// Stop current time book recording.
				
				if (e.doubleClick) {
					
					this.$store.commit("stopTimeBookRecording", {
						
						user_id: this.$auth.user().id,
						
						callback: () => {
							
							this.$store.commit("toggleTimeBookRecording", {
								
								client_id: e.ticket.project.client_id,
								project_id: e.ticket.project.id,
								ticket_id: e.ticket.id,
								
								ticket: e.ticket,
								
								project_name: e.ticket.project.name,
								
								user_id: this.$auth.user().id,
								
							});
							
						},
						
					});
					
				}*/
				
			}
			
		},
		
		created() {
			
			// Get my tickets.
			
			this.axios.get("my-tickets/" + this.$auth.user().id).then((response) => {
				this.assignedTickets = response.data;
			}).catch((e) => {
				
			});
			
			// Get my overdue tickets!
			
			this.axios.get("my-overdue-tickets/" + this.$auth.user().id).then((response) => {
				this.overdueTickets = response.data;
			}).catch((e) => {
				
			});
			
		}
		
	}
	
</script>

<style scoped>
	
	
	
</style>


// WEBPACK FOOTER //
// src/components/Dashboard/Dashboard.vue